import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { BudgetFiscalYearService, Pagination } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-select-budget-fiscal-year',
  templateUrl: './select-budget-fiscal-year.component.html',
  styleUrls: ['./select-budget-fiscal-year.component.css']
})
export class SelectBudgetFiscalYearComponent implements OnInit {

  @Input() budgetFiscalYearControl = new FormControl();
  @Output() selectionChange = new EventEmitter();
  @Input() votebookGuid;
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  budgetFiscalYears: any[] = [];
  toppingsControl = new FormControl([]);
  filteredBudgetFiscalYears: any[] = [];
  newFilteredBudgetFiscalYears: any[] = [];

  @ViewChild("budgetFiscalYearInput") budgetFiscalYearInput: ElementRef<HTMLInputElement>;
  budgetFiscalYearTargets: string[] = [];

  constructor(
    private budgetFiscalYearService: BudgetFiscalYearService
  ) {}

  ngOnInit(): void {
    this.viewModelStore
    .select(this.ColumnViewSelectors.selectAdvanceSearch_BudgetFiscalYear_Field)
    .subscribe((data) => {
      this.budgetFiscalYears = data;
    });

    let pagination = new Pagination();
    pagination.offset = 0;
    pagination.limit = 10000;
    pagination.conditionalCriteria = [
      {
        columnName: "votebook_guid",
        operator: "=",
        value: this.votebookGuid,
      },
    ];

    this.subs.sink = this.budgetFiscalYearService
      .getByCriteria(pagination, AppConfig.apiVisa)
      .subscribe({
        next: (results) => {
          results.data.forEach((item) => {
            this.filteredBudgetFiscalYears.push(item.bl_fi_budget_fiscal_year);
          });
          this.newFilteredBudgetFiscalYears = this.filteredBudgetFiscalYears;
          console.log("Budget FiscalYears", this.newFilteredBudgetFiscalYears); // Output the results
        },
        complete: () => {
          console.log("All requests completed.");
        },
        error: (error) => {
          console.error("An error occurred:", error);
        },
      });
    this.budgetFiscalYearControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((data) => this.filterBudgetFiscalYear(data));
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || "").trim();
    // Add our budgetFiscalYear
    if (value) {
      this.budgetFiscalYears.push(value);
    }

    // Clear the input value
    event.input.value = "";

    this.budgetFiscalYearControl.setValue(null);

    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BudgetFiscalYearField({
        budgetFiscalYears: this.budgetFiscalYears,
      })
    );
  }

  remove(budgetFiscalYear: string): void {
    const index = this.budgetFiscalYears.indexOf(budgetFiscalYear);

    if (index >= 0) {
      this.budgetFiscalYears.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BudgetFiscalYearField({
        budgetFiscalYears: this.budgetFiscalYears,
      })
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(event.option);
    this.budgetFiscalYears.push(event.option.value);
    this.budgetFiscalYearInput.nativeElement.value = "";
    this.budgetFiscalYearControl.setValue(null);
  }

  filterBudgetFiscalYear(filterValue: string) {
    filterValue = filterValue?.trim().toLowerCase(); // Remove whitespace and make it lowercase
    this.filteredBudgetFiscalYears = this.newFilteredBudgetFiscalYears.filter((option) =>
      option.code.toLowerCase().includes(filterValue)
    );
  }

  optionClicked(event: Event, budgetFiscalYear: any) {
    event.stopPropagation();
    this.toggleSelection(budgetFiscalYear);
  }

  toggleSelection(budgetFiscalYear: any) {
    console.log(budgetFiscalYear);
    budgetFiscalYear.selected = !budgetFiscalYear.selected;
    this.budgetFiscalYearInput.nativeElement.value = "";
    if (budgetFiscalYear.selected) {
      this.budgetFiscalYears.push(budgetFiscalYear);
    } else {
      const i = this.budgetFiscalYears.findIndex(
        (value) => value.guid === budgetFiscalYear.guid
      );
      this.budgetFiscalYears.splice(i, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BudgetFiscalYearField({
        budgetFiscalYears: this.budgetFiscalYears,
      })
    );
  }

  onReset() {
    this.budgetFiscalYears = [];
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
